declare global {
    interface Window {
        fragmentedAccess: (token: string) => Promise<void>;
        webkit: any;
        appInterface: any;
    }
}

export const mobileIntegration = {
    isIOSNativeApp(): boolean {
        return window?.webkit?.messageHandlers?.appInterface !== undefined;
    },

    isAndroidNativeApp(): boolean {
        return window.appInterface !== undefined;
    },

    isNativeApp(): boolean {
        return this.isAndroidNativeApp() || this.isIOSNativeApp();
    },

    postMessage(message: string): void {
        if (this.isIOSNativeApp()) {
            window.webkit.messageHandlers.appInterface.postMessage(message);
        } else if (this.isAndroidNativeApp()) {
            window.appInterface.postMessage(message);
        }
    },
};

export default mobileIntegration;
